import { EnumList, GenderTypeEnum } from 'common/constants/enum';
import { Input } from 'components/elements';
import RoleSelectMultiInput from 'legacy-modules/master/role/components/select-multi-input';
import EnumSelectInput from 'legacy-modules/master/select-input/enum';
// import EnumSelectInput from 'modules/master/select-input/enum';
import { HalfContainer, SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  hasData?: boolean;
}

export default function EmployeeInformationForm(props: Props) {
  const { t } = useTranslation();

  const { hasData } = props;

  return (
    <>
      <SectionContainer>
        <HalfContainer>
          <Input
            label={t('admin:full_name')}
            placeholder={t('admin:full_name')}
            name="name"
            type="text"
            fontCase="TitleCase"
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            label={t('common:username')}
            placeholder={t('common:username')}
            name="username"
            type="text"
            required
          />
        </HalfContainer>
      </SectionContainer>
      <Input
        type="radio-group"
        name="gender"
        options={[
          { value: GenderTypeEnum.Male, children: t('common:male') },
          { value: GenderTypeEnum.Female, children: t('common:female') },
        ]}
        label={t('common:gender')}
        required
        align="horizontal"
      />
      <SectionContainer>
        <HalfContainer>
          <Input
            label={t('admin:password')}
            placeholder={t('admin:password')}
            name="password"
            type="password"
            required={!hasData}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            label={t('admin:password_confirmation')}
            placeholder={t('admin:password_confirmation')}
            name="passwordConfirmation"
            type="password"
            required={!hasData}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            label={t('common:phone_number')}
            placeholder={t('common:phone_number')}
            name="phone"
            type="tel"
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            label={t('cruise:cellphone_number')}
            placeholder={t('cruise:cellphone_number')}
            name="phone_2"
            type="tel"
          />
        </HalfContainer>
      </SectionContainer>
      <Input
        label={t('common:address')}
        placeholder={t('common:address')}
        name="address"
        type="text"
        fontCase="TitleCase"
      />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="joinedAt"
            label={t('common:join_date')}
            placeholder={t('common:join_date')}
          />
        </HalfContainer>
        <HalfContainer>
          <EnumSelectInput
            enumType={EnumList.EmployeeJobLevel}
            name="jobLevel"
            label={t('common:job_level')}
            placeholder={t('common:job_level')}
            disabled={hasData}
          />
        </HalfContainer>
      </SectionContainer>
      <RoleSelectMultiInput
        label={t('common:role')}
        placeholder={t('common:select_role')}
        name="roles"
      />
    </>
  );
}
